<template>
  <ion-item lines="none">
    <ion-select
        :label="$t('interface.representation')"
        interface="action-sheet"
        :value="themePreference"
        @ionChange="changeThemePreference"
        :cancelText="$t('interface.cancel')"
    >
      <ion-select-option value="system">{{ $t('system') }}</ion-select-option>
      <ion-select-option value="ligh">{{ $t('lightMode') }}</ion-select-option>
      <ion-select-option value="dark">{{ $t('darkMode') }}</ion-select-option>
    </ion-select>
  </ion-item>
</template>

<script>
import {IonItem, IonSelect, IonSelectOption} from "@ionic/vue";

import {computed, defineComponent} from 'vue'
import {useStore} from "vuex";

export default defineComponent({
  setup() {
    const store = useStore();
    const themePreference = computed(() => store.state.themePreference);

    const changeThemePreference = value => {
      const isSystemThemePreferenceDark = window.matchMedia("(prefers-color-scheme: dark)").matches

      const ionPaletteDark = value.detail.value === 'system' ? isSystemThemePreferenceDark : value.detail.value === 'dark'
      document.documentElement.classList.toggle('ion-palette-dark', ionPaletteDark);

      localStorage.setItem('themePreference', value.detail.value)
      store.commit('setThemePreference', value.detail.value)
    }

    return { changeThemePreference, themePreference }
  },
  props: {
    icon: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IonItem,
    IonSelect,
    IonSelectOption,
  }
})

</script>

<style lang="scss" scoped>
ion-item {
  --background: transparent !important;
}
</style>
